import { EXAM_WORKED_DONE, EXAM_WORKING, EXAM_DONT_WORK } from './constants'

export default {
  
  methods: {

    checkTypeExam (type) {
      switch (type) {
        case EXAM_WORKED_DONE:
          return 'Đã hoàn thành'
          break;
        case EXAM_WORKING:
          return 'Chưa hoàn thành'
          break;
        default:
          return 'Chưa làm'
          break;
      }
    }
  }
}